export const gettingStartedContent = `
Get up and running with Reqqy in under five minutes. Follow these steps to submit your first requirements review.

{% step num="1" title="Create an account" %}
Sign up with your email and verify your address. You'll get free monthly credits to start reviewing immediately.
{% /step %}

{% step num="2" title="Create a project" %}
Organize your work by creating a project. Projects help you group related requirements and track improvements over time.
{% /step %}

{% step num="3" title="Submit requirements" %}
Paste your requirements text — user stories, feature specs, PRDs, or acceptance criteria — into the review wizard.
{% /step %}

{% step num="4" title="Configure your review" %}
Choose your review mode (Quick, Standard, or Deep), select personas to simulate stakeholder perspectives, and set your preferences.
{% /step %}

{% step num="5" title="Review results" %}
Get a detailed clarity score, flagged issues, rewritten suggestions, and clarifying questions — all in seconds.
{% /step %}
`;
